import storeLocal from 'store';

const replaceBracket = (function () {
  let localConfigSetting = storeLocal.get('Pwm-configSetting');
  let configReplace = {};
  if (localConfigSetting) {
    configReplace = {
      count: localConfigSetting.deliverSetting.maxToNumSingle
    }
  }
  return function (msgStr) {
    for (let key in configReplace) {
      msgStr = msgStr.replace(new RegExp('\\{' + key + '\\}', 'g'), configReplace[key])
    }
    return msgStr
  }
})();

export default replaceBracket;



// WEBPACK FOOTER //
// ./src/utils/replaceBracket.js